import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HomeAbout } from '../components/HomeAbout';
import { HomeServices } from '../components/HomeServices';
import { HowToBook } from '../components/HowToBook';
import { IGSlider } from '../components/IGSlider';
import { FAQSection } from '../components/FAQSection';
import { ContactSection } from '../components/ContactSection';
import { ReviewCTA } from '../components/ReviewCTA';
import { SocialPromo } from '../components/SocialPromo';
export function HomePage() {
  return <div className="bg-cream" data-id="element-628">
      <HeroSection data-id="element-629" />
      <HomeAbout data-id="element-630" />
      <HomeServices data-id="element-631" />
      <HowToBook data-id="element-632" />
      <SocialPromo data-id="element-633" />
      <IGSlider data-id="element-634" />
      <ReviewCTA data-id="element-635" />
      <FAQSection data-id="element-636" />
      <ContactSection data-id="element-637" />
    </div>;
}